export enum MixpanelEvent {
    PAGE_VIEWED = 'page_viewed',
    BUTTON_CLICKED = 'button_clicked',
    SIGNUP_STARTED = 'signup_started',
    SIGNUP_COMPLETED = 'signup_completed',
    LOGIN_STARTED = 'login_started',
    LOGIN_SUCCESS = 'login_success',
    LOGOUT = 'logout',
    JOIN_FREE='join_free',
    SESSION_STARTED='session_started',
    NAVIGATION_STARTED='navigation_started',
    NAVIGATION_FAILED='navigation_failed',
    NAVIGATION_COMPLETED='navigation_completed'


    
  }
  